export class DigitalUnitConverterHelper {

  static byteToMB(value: number): number {
    return value / (1000000);
  }
}
